module.exports = __webpack_public_path__ + "img/Glyphe_Dos.fac9c275.png";